import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgProgress, NgProgressRef } from '@ngx-progressbar/core';

@Component({
    selector: 'app-supplier-portal-home',
    templateUrl: './supplier-portal-home.component.html',
    styleUrls: ['./supplier-portal-home.component.css']
  })

  export class SupplierPortalHome implements OnInit {
    constructor(
      private ngProgress: NgProgress,
    ){}

    progressRef: NgProgressRef
    selectedCol = '1';

    @Input()
    enrichData: any;

    @Input()
    departmentSheet: any;

    @Input()
    me: any;

    @Input()
    proformasByProvider: any;

    @Input()
    discrepancies: any;

    @Input()
    packagings: any;

    @Input()
    files: any;

    @Input()
    followId: any;

    @Output()
    downloadEnrich = new EventEmitter()

    @Output()
    downloadDiscrepanciesS = new EventEmitter()

    @Output()
    changeFilterDataSend = new EventEmitter()

    @Output()
    fileInputChanges = new EventEmitter()

    @Output()
    uploadSupplierDiscrepancies = new EventEmitter()

    @Output()
    downloadPackagings = new EventEmitter()

    @Output()
    downloadDiscrepanciesSupplier = new EventEmitter()

    @Output()
    uploadPackagings = new EventEmitter()

    @Output()
    downloadAllSupplier = new EventEmitter()

    @Output()
    uploadsMassives = new EventEmitter()

    @Output()
    downloadFiles = new EventEmitter()

    @Output()
    supplierFiles = new EventEmitter()

    @Output()
    changeFollowIds = new EventEmitter()

    get totalProducts(){
      let sum = 0
      this.enrichData.forEach((item: any) => {
        sum += item.Products.length
      })
      return sum
    }

    get dataSupplier(){
      return this.enrichData || []
    }

    get show(){
      return this.me && (this.me.role === 'product-manager' || this.me.role === 'merchant')  
    }
    
    ngOnInit() {
      this.progressRef = this.ngProgress.ref();
    }

    totalDis(){
      let totalDis = 0
      if(this.show){
        this.discrepancies.forEach((d) => {
          totalDis += d.suppliers.length
        })
      }else{
        totalDis = this.discrepancies.length
      }
      return totalDis
    }

    totalPack(){
      let totalp = 0
      if(this.show){
        let sumPack = 0
        this.packagings.forEach((p) => {
          sumPack += p.providersWithFieldsCount.filter((pp) => pp.fieldsEmpty !== 0).length
        });
        totalp = sumPack
      }else{
        totalp = this.packagings.length
      }
      return totalp
    }

    changeTables(n){
      this.selectedCol = n
    }

    download(e){
      this.downloadEnrich.emit(e)
    }

    downloadDiscre(e){
      this.downloadDiscrepanciesS.emit(e)
    }

    downloadDiscrepanciesSuppliers(e){
      this.downloadDiscrepanciesSupplier.emit(e)
    }

    changeFilter(e){
      this.changeFilterDataSend.emit(e)
    }

    fileInputChange(e){
      this.fileInputChanges.emit(e)
    }

    uploadSupplierDiscrepanciess(e){
      this.uploadSupplierDiscrepancies.emit(e)
    }

    downloadPackaging(e){
      this.downloadPackagings.emit(e)
    }

    uploadPackaging(e){
      this.uploadPackagings.emit(e)
    }

    downloadAllSuppliers(e){
      this.downloadAllSupplier.emit(e)
    }

    uploadsMassive(e){
      this.uploadsMassives.emit(e)
    }

    downloadFile(e){
      this.downloadFiles.emit(e)
    }

    supplierFile(e){
      this.supplierFiles.emit(e)
    }

    changeFollowId(e){
      this.changeFollowIds.emit(e)
      this.selectedCol = "1"
    }
  }